import React from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import Hint from "../../utils/Hint/Hint";

import "./landingSection.css";

const LandingSection = ({
  allMenus,
  isAllMenusLoading,
  orders,
  isActiveOrdersLoading
}) => {
  return (
    <div className="section landingSection">
      <Hint
        hintHeading="Admin sub application"
        hintText={`
        <div>
        This sub-application is the core of the CMS/CRM system, responsible for the management of the whole application, including:
        <ul>
        <li>Handling current orders</li>
        <li>Managing menus in the database</li>
        <li>Managing items in the database</li>
        <li>Adjusting application-level configurations</li>
        <li>Monitoring orders statistics</li>
        <li>Editing text and media content of the customer-facing application</li>
        </ul>
        <div>
        This static demo helps to build the impression of the system's capabilities.
        </div>
        <div>
        The application is built with responsive design in mind, allowing a comfortable workflow on any device.
        </div>
        <div>
        On a desktop device, try to change the browser's window width or use the developer's tools (<code>Ctrl + Shift + I</code>) to see the interface adapt to the screen size.
        </div>
        </div>
        `}
        openOnMount={false}
        top="5em"
      />
      <h2 className="sectionHeading">dashboard</h2>
      {!isAllMenusLoading && !isActiveOrdersLoading ? (
        <div className="landingSection__gistDiv">
          <div className="gistDiv__container">
            <h3>Orders</h3>
            <div>
              {orders.length > 0 || orders.length > 0 ? (
                <div className="gistDiv__container__ordersGist">
                  <h3 className="gistDiv__container__ordersGist_heading">
                    Active orders: {orders.filter((o) => o.active).length}
                  </h3>
                  <div className="gistDiv__container__typeGist">
                    <p>
                      Requested:{" "}
                      {
                        orders
                          .filter((o) => o.active)
                          .filter((order) => order.orderStatus === "requested")
                          .length
                      }
                    </p>
                    <p>
                      Accepted:{" "}
                      {
                        orders
                          .filter((o) => o.active)
                          .filter((order) => order.orderStatus === "accepted")
                          .length
                      }
                    </p>
                    <p>
                      Fulfilled:{" "}
                      {
                        orders
                          .filter((o) => o.active)
                          .filter((order) => order.orderStatus === "fulfilled")
                          .length
                      }
                    </p>
                    <p>
                      Cancelled:{" "}
                      {
                        orders
                          .filter((o) => o.active)
                          .filter((order) => order.orderStatus === "cancelled")
                          .length
                      }
                    </p>
                    <p>In database: {orders.length}</p>
                  </div>
                </div>
              ) : (
                "No active orders"
              )}
            </div>
            <NavLink className="gistDivLink" to={"/orders"}>
              Orders
            </NavLink>
          </div>
          <div className="gistDiv__container">
            <h3>Menus</h3>
            <div>
              {allMenus.length > 0 || allMenus.length > 0 ? (
                <div className="gistDiv__container__ordersGist">
                  <h3 className="gistDiv__container__ordersGist_heading">
                    Menus on website: {allMenus.filter((m) => m.active).length}
                  </h3>
                  <div className="gistDiv__container__typeGist">
                    <p>
                      Daily menus:{" "}
                      {
                        allMenus.filter((m) => m.websitePurpose === "dailyMenu")
                          .length
                      }
                    </p>
                    <p>
                      To-order menus:{" "}
                      {
                        allMenus.filter((m) => m.websitePurpose === "orderMenu")
                          .length
                      }
                    </p>
                    <p>
                      Static menus:{" "}
                      {
                        allMenus.filter((m) => m.websitePurpose === "static")
                          .length
                      }
                    </p>
                    <p>
                      Print menus:{" "}
                      {allMenus.filter((m) => m.purposeType === "print").length}
                    </p>
                    <p>In database: {allMenus.length}</p>
                  </div>
                </div>
              ) : (
                "No menus in the database"
              )}
            </div>
            <NavLink className="gistDivLink" to={"/menus"}>
              Menus
            </NavLink>
          </div>
        </div>
      ) : (
        <div className="landingSection__loadingDiv">
          <div className="lds-grid">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingSection;
